/* Studio Spice · Find your blend quiz */
(function () {
  var root = document.querySelector('[data-sbq]'); if (!root) return;
  var d = document, w = window;
  var intro = root.querySelector('[data-sbq-intro]'), flow = root.querySelector('[data-sbq-flow]'), results = root.querySelector('[data-sbq-results]');
  var dots = root.querySelector('[data-sbq-dots]'), back = root.querySelector('[data-sbq-back]'), next = root.querySelector('[data-sbq-next]'), count = root.querySelector('[data-sbq-count]'), bar = root.querySelector('[data-sbq-bar]');
  var steps = {}; Array.prototype.forEach.call(root.querySelectorAll('.sbq-step'), function (s) { steps[s.getAttribute('data-step')] = s; });
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tOf = root.getAttribute('data-t-of') || 'of', tQ = root.getAttribute('data-t-q') || 'Question';
  var history = [], current = null, pointer = false, timer = null;

  function val(key) { var s = steps[key]; if (!s) return null; var c = s.querySelector('input:checked'); return c ? c.value : null; }
  function vals(key) { var s = steps[key]; if (!s) return []; return Array.prototype.map.call(s.querySelectorAll('input:checked'), function (i) { return i.value; }); }
  function echo(key) { var s = steps[key]; if (!s) return ''; var c = s.querySelector('input:checked'); return c ? (c.getAttribute('data-echo') || '') : ''; }

  function route(key) {
    var need = val('q1');
    switch (key) {
      case 'q1': return { cycle: 'phase', digestion: 'digest', calm: 'calm', energy: 'energy' }[need] || 'style';
      case 'phase': return 'feel';
      case 'style': return null;
      default: return 'style';
    }
  }
  function total() { var n = val('q1'); return n === 'cycle' ? 4 : n === 'curious' ? 2 : n ? 3 : 4; }
  function outcome() {
    var need = val('q1');
    if (need === 'cycle') {
      if (vals('feel').indexOf('irregular') > -1) return 'pcos';
      return { period: 'shed', after: 'bloom', mid: 'bloom', before: 'root' }[val('phase')] || 'bundle';
    }
    return { digestion: 'agni', calm: 'butterfly', energy: 'cacao' }[need] || 'bundle';
  }

  function show(el) { el.hidden = false; if (!reduce) { el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); } }
  function syncNext() {
    var s = steps[current]; if (!s) return;
    next.disabled = !(s.getAttribute('data-multi') || s.querySelector('input:checked'));
  }
  function go(key, isBack) {
    clearTimeout(timer);
    if (!isBack && current) history.push(current);
    Object.keys(steps).forEach(function (k) { steps[k].hidden = true; });
    current = key;
    intro.hidden = true; results.hidden = true; flow.hidden = false;
    try { var u0 = new URL(w.location.href); if (u0.searchParams.has('result')) { u0.searchParams.delete('result'); w.history.replaceState(null, '', u0); } } catch (err) {}
    var s = steps[key]; show(s);
    var n = history.length + 1, t = Math.max(total(), n);
    count.textContent = n + ' ' + tOf + ' ' + t;
    if (bar) bar.style.transform = 'scaleX(' + (n / t).toFixed(3) + ')';
    if (dots) { var h = ''; for (var i = 1; i <= t; i++) h += '<i class="' + (i < n ? 'is-done' : i === n ? 'is-now' : '') + '"></i>'; dots.innerHTML = h; }
    next.parentNode.hidden = !(s.getAttribute('data-multi') || s.querySelector('input:checked'));
    syncNext();
    var lg = s.querySelector('legend'); if (lg) { lg.setAttribute('tabindex', '-1'); lg.focus({ preventScroll: true }); }
    if (flow.getBoundingClientRect().top < 0) flow.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  function advance() { var n = route(current); if (n) go(n); else finish(); }
  function finish(key) {
    key = key || outcome();
    if (current) history.push(current);
    flow.hidden = true; intro.hidden = true;
    Array.prototype.forEach.call(results.querySelectorAll('[data-result]'), function (r) { r.hidden = r.getAttribute('data-result') !== key; });
    var res = results.querySelector('[data-result="' + key + '"]');
    if (res) {
      var txt = echo('phase') || echo('digest') || echo('calm') || echo('energy');
      var f = steps.feel ? steps.feel.querySelector('input:checked:not([value="fine"])') : null;
      var fe = f ? (f.getAttribute('data-echo') || '') : '';
      if (f && f.value === 'irregular') txt = fe;
      else if (fe && txt) txt = txt.replace(/\.$/, '') + ', ' + fe + '.';
      var li = res.querySelector('[data-sbq-echo]');
      if (li) { li.textContent = txt; li.hidden = !txt; li.classList.remove('is-late'); if (!reduce) { void li.offsetWidth; li.classList.add('is-late'); } }
      var st = val('style'); if (!st || st === 'surprise') st = 'slow';
      Array.prototype.forEach.call(res.querySelectorAll('[data-style]'), function (p) { p.hidden = p.getAttribute('data-style') !== st || !p.textContent.trim(); });
      if (!res.querySelector('[data-style]:not([hidden])')) { var q = res.querySelector('[data-style="quick"]'); if (q) q.hidden = false; }
    }
    var cyc = ['shed', 'bloom', 'root', 'pcos'].indexOf(key) > -1 || (key === 'bundle' && val('q1') === 'cycle');
    var opt = results.querySelector('[data-sbq-phase-opt]'); if (opt) opt.hidden = !cyc;
    var tags = results.querySelector('[data-sbq-tags]'); if (tags) tags.setAttribute('data-base', 'newsletter,quiz,quiz-' + key + ',lang-' + (d.documentElement.lang || 'en').slice(0, 2));
    show(results);
    try { var u = new URL(w.location.href); u.searchParams.set('result', key); w.history.replaceState(null, '', u); } catch (err) {}
    results.focus({ preventScroll: true });
    results.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  function restart() {
    flow.reset(); history = []; current = null; results.hidden = true; flow.hidden = true; show(intro);
    try { var u = new URL(w.location.href); u.searchParams.delete('result'); w.history.replaceState(null, '', u); } catch (err) {}
    intro.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  root.querySelector('[data-sbq-start]').addEventListener('click', function () { go('q1'); });
  back.addEventListener('click', function () {
    if (!history.length) { flow.hidden = true; current = null; show(intro); return; }
    go(history.pop(), true);
  });
  next.addEventListener('click', function () { if (!next.disabled) advance(); });
  flow.addEventListener('pointerdown', function () { pointer = true; });
  flow.addEventListener('keydown', function (e) {
    pointer = false;
    if (e.key === 'Enter' && e.target.matches('input')) { e.preventDefault(); if (e.target.type === 'radio') { e.target.checked = true; syncNext(); advance(); } else { advance(); } }
  });
  flow.addEventListener('change', function (e) {
    var s = steps[current]; if (!s) return;
    syncNext();
    if (e.target.type === 'radio') {
      next.parentNode.hidden = pointer;
      if (pointer) { clearTimeout(timer); timer = setTimeout(advance, reduce ? 0 : 420); }
    }
  });
  root.querySelector('[data-sbq-restart]').addEventListener('click', restart);
  var edit = root.querySelector('[data-sbq-edit]'), rs = root.querySelector('[data-sbq-restart]');
  if (!edit && rs) { edit = d.createElement('button'); edit.type = 'button'; edit.className = 'sbq-link'; edit.setAttribute('data-sbq-edit', ''); edit.textContent = /^nl/.test(d.documentElement.lang) ? 'Antwoorden aanpassen' : 'Change my answers'; rs.parentNode.insertBefore(edit, rs); }
  if (edit) edit.addEventListener('click', function () { if (history.length) go(history.pop(), true); else restart(); });

  /* email: stay on the page */
  var mail = d.getElementById('SbQuizMail');
  if (mail) mail.addEventListener('submit', function (e) {
    if (!w.fetch || !w.FormData) return;
    e.preventDefault();
    var tags = mail.querySelector('[data-sbq-tags]'), chk = mail.querySelector('[data-sbq-phase-check]');
    tags.value = (tags.getAttribute('data-base') || 'newsletter,quiz') + (chk && chk.checked && !chk.closest('[hidden]') ? ',phase-emails' : '');
    var btn = mail.querySelector('button[type="submit"]'); btn.disabled = true;
    fetch(mail.action, { method: 'POST', body: new FormData(mail), credentials: 'same-origin' }).then(function (r) {
      if (/challenge/.test(r.url)) { mail.submit(); return; }
      mail.querySelector('.sbq-mail__field').hidden = true;
      Array.prototype.forEach.call(mail.querySelectorAll('.sbq-check,.sbq-flabel,.sbq-fine'), function (x) { x.hidden = true; });
      var ok = mail.querySelector('.sbq-ok'); ok.hidden = false;
    }).catch(function () { mail.submit(); });
  });

  /* shared link: ?result=root */
  try { var r = new URL(w.location.href).searchParams.get('result'); if (r && results.querySelector('[data-result="' + r + '"]')) { history = []; finish(r); history = []; } } catch (err) {}
})();
